/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum FilterMetricOperator {
    Equal = 'equal',
    NotEqual = 'not_equal',
    GreaterThan = 'greater_than',
    GreaterEqualThan = 'greater_equal_than',
    LessThan = 'less_than',
    LessEqualThan = 'less_equal_than',
}
